module.exports = __webpack_public_path__ + "static/media/253221644482797welcome.b8d4c04f.jpg";